import { PlatformModule } from '@angular/cdk/platform';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeEsCO from '@angular/common/locales/es-CO';
import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JwtModule } from '@auth0/angular-jwt';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { CiamActiveDirectoryV2Module } from 'ciam-active-directory-ang9x';
import { NgxSpinnerModule } from "ngx-spinner";
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DetalleSolicitudMultiComponent } from './components/individual-retreat/request-list-notifi/DetalleSolicitudMulti/detalleSolicitudMulti.component';
import { InformacionComponent } from './components/individual-retreat/request-list-notifi/DetalleSolicitudMulti/informacion.component';
import { MultiBeneficiarioComponent } from './components/individual-retreat/request-list-notifi/multibeneficiario/multibeneficiario.component';
import { LoginComponent } from './components/login/login.component';
import { NotAuthorizedComponent } from './components/not-authorized/not-authorized.component';
import { AuthTokenProvider } from './core/interceptors/auth/auth-interceptor';
import { ErrorInterceptor } from './core/interceptors/error/error-interceptor';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { MainLayoutModule } from './layouts/main-layout/main-layout.module';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localeEsCO, 'es-CO');

const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: "middle",
      distance: 12,
    },
    vertical: {
      position: "top",
      distance: 12,
      gap: 10,
    },
  },
  theme: "material",
  behaviour: {
    autoHide: 5000,
    onClick: "hide",
    onMouseover: "pauseAutoHide",
    showDismissButton: true,
    stacking: 4,
  },
  animations: {
    enabled: true,
    show: {
      preset: "slide",
      speed: 300,
      easing: "ease",
    },
    hide: {
      preset: "fade",
      speed: 300,
      easing: "ease",
      offset: 50,
    },
    shift: {
      speed: 300,
      easing: "ease",
    },
    overlap: 150,
  },
};


export function tokenGetter() {
  return localStorage.getItem(environment.LOCAL_STORAGE.LOGIN_USER_TOKEN);
}

@NgModule({
  declarations: [
    AppComponent,
    MainLayoutComponent,
    NotAuthorizedComponent,
    MultiBeneficiarioComponent,
    DetalleSolicitudMultiComponent,
    InformacionComponent,
    LoginComponent,
  ],
  imports: [
    BrowserModule,
    PlatformModule,
    MatExpansionModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MainLayoutModule,
    SharedModule,
    MatProgressSpinnerModule,
    NgxSpinnerModule,
    CiamActiveDirectoryV2Module,
    NotifierModule.withConfig(customNotifierOptions),
    JwtModule.forRoot({
      config: { tokenGetter }
  }),
  CalendarModule.forRoot({
    provide: DateAdapter,
    useFactory: adapterFactory
  })
  ],
  providers: [
    AuthTokenProvider,
    {provide: LOCALE_ID, useValue: 'es-CO'},
    {
      provide: ErrorHandler,
      useClass: ErrorInterceptor
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor() {
    registerLocaleData(localeEsCO);
  }
}
